<template>
    <el-dialog title="页面二维码" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small">
          <el-form-item label="网页二维码"  v-auth="'/appsetting/appmp/index'" :label-width="formLabelWidth">
            <el-image 
              style="width: 100px; height: 100px"
              :src="dataModel.mp_qrcode" 
              :preview-src-list="[dataModel.mp_qrcode]">
            </el-image>
          </el-form-item>
          <el-form-item label="小程序码"  v-auth="'/appsetting/appwx/index'" :label-width="formLabelWidth">
            <el-image 
              style="width: 100px; height: 100px"
              :src="dataModel.wx_qrcode" 
              :preview-src-list="[dataModel.wx_qrcode]">
            </el-image>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
            };
        },
        props: ['is_open', 'dataModel'],
        created() {
          this.dialogVisible = this.is_open;
        },
        methods: {
            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('closeDialog', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/image/qrcode.vue